import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class AuthenticationService {
    login (loginRequest) {
        var request = {
            Site: loginRequest.siteId,
            Login: loginRequest.userId,
            Password: loginRequest.password,
            Product: loginRequest.product,
            ReturnUrl: loginRequest.returnUrl
        };

        return axios
            .post(UrlHelper.getIdentifiUrl() + 'AuthActions/LegacyLogin', request);
    }

    loginAndChangePassword (request) {
        return axios
            .post(UrlHelper.getIdentifiUrl() + 'AuthActions/LegacyLoginForExpiredPassword', request);
    }

    impersonate (request) {
        return axios
            .post(UrlHelper.getIdentifiUrl() + 'AuthActions/SuperUserImpersonate', request);
    }

    virtualUserImpersonate (request) {
        return axios
            .post(UrlHelper.getIdentifiUrl() + 'AuthActions/VirtualUserImpersonate', request);
    }

    loginToSisense (orgId, virtualUserId) {
        return axios
            .post(UrlHelper.getCentralManagementApiUrl() + 'analytics/sso/impersonate?orgId='+ orgId +'&virtualUserId=' + virtualUserId, null, { withCredentials: true });
    }
}

export default new AuthenticationService();
